export default __webpack_public_path__ + "static/media/terrible@3x.842f937d.png";